export default {"src":"/_next/static/media/3.338b3a75.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};